
  import createMeisterIcons from '../src/createMeisterIcons';

  const LockPartialopen = createMeisterIcons("lock-partialopen", [["path",{"fill":"currentColor","d":"M12 3.75A3.26 3.26 0 0 0 8.75 7v2.082a6.75 6.75 0 1 1-1.5 1.122V7A4.76 4.76 0 0 1 12 2.25c1.328 0 2.512.601 3.33 1.42.819.818 1.42 2.002 1.42 3.33a.75.75 0 0 1-1.5 0c0-.872-.399-1.688-.98-2.27-.582-.581-1.398-.98-2.27-.98m0 6a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m.75 6.25a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0z","key":"bcece3f4b23aa17d255c72b044e0d47cb49f9da6","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default LockPartialopen
  